import styled from 'styled-components';
import { maxWidth, MaxWidthProps, MarginProps, LayoutProps, FlexboxProps } from 'styled-system';
import { Anchor } from '@bpba/ui-components';
import { SelloData } from '../../model/SelloData';

type Props = {
  data: SelloData;
} & MarginProps &
  LayoutProps &
  FlexboxProps;

export const Sello = ({ data, ...otherProps }: Props) => {
  return (
    <Anchor data={data} variant={'transparent'} width={['fit-content', '100%']} height={[61, 77, null, 67]} {...otherProps}>
      <Img maxWidth={['165px', '210px', null, '182px']} src={data.imagenUrl} alt={data.textoAlternativo} />
    </Anchor>
  );
};

const Img = styled.img<MaxWidthProps>(maxWidth, { height: '100%', width: '100%' });
